exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-56ae83be] .vc-container{border:none}", ""]);

// exports
